import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../../generic';

import styles from './Loading.module.less';

/**
 * Renders the "Loading" state of the Test Dependency card, which is shown
 * while FOSSA is validating the provided dependency revision.
 */
const Loading: VoidFunctionComponent = () => {
  return (
    <div className={styles.loading}>
      <Icon icon={icons.spinner} size="fa-3x" hasSpin />
    </div>
  );
};

export default Loading;
